// extracted by mini-css-extract-plugin
export default {"main":"styles_main__Rt3zw","item":"styles_item__tmpX-"};